import {useInjex} from '@injex/react-plugin';
import ReportingMetaDataManager from '../managers/ReportingMetaDataManager.mdl';

export default function useReportingMetaDataManager(): ReportingMetaDataManager {
    const [inject] = useInjex();
    return inject<ReportingMetaDataManager>('reportingMetaDataManager');
}
